<template>
  <b-form @submit="onSubmit">
    <b-form-group
      id="input-group-name"
      label="Nom"
      label-for="input-name">
      <b-form-input
        id="input-name"
        v-model="form.train_name"
        type="text"
        required
      />
    </b-form-group>

    <b-form-group
      id="input-group-description"
      label="Description"
      label-for="input-description">
      <b-form-textarea
        id="input-description"
        v-model="form.train_description"
        type="text"
        required
      />
    </b-form-group>


    <b-form-group
      id="input-group-usages"
      label="Usages"
      label-for="input-usages">
      <b-form-select
        v-model="form.train_usages"
        :options="usagesValues"
        multiple/>
    </b-form-group>
    <b-form-group
      id="input-group-needs"
      label="Besoins"
      label-for="input-needs">
      <b-form-select
        v-model="form.train_needs"
        :options="needsValues"
        multiple/>
    </b-form-group>

    <b-form-group
      id="input-group-offers"
      label="Offres"
      label-for="input-offers">
      <b-form-select
        v-model="form.train_offers"
        :options="offersValues"
        multiple/>
    </b-form-group>
    <div class="separation_line" />
    <b-row
      align-h="end"
      class="mb-2">
      <b-col
        class="text-right"
        cols="8"
        align-self="end">
        <b-button
          v-b-modal.modal-document-add
          variant="success">Ajouter un nouveau document</b-button>
        <b-modal
          id="modal-document-add"
          title="Ajouter un nouveau document de formation"
          scrollable
          hide-footer>
          <div class="alert-warning mt-3 mb-3 p-2">Attention, le nom du document fait foi et doit être unique.</div>
          <b-form @submit="onSubmitDocument">
            <b-form-file
              v-model="form.list"
              :state="Boolean(form.list)"
              placeholder="Choisissez un fichier ou déposez-le ici..."
              drop-placeholder="Déposez-le ici..."
            />
            <div
              v-if="form.list"
              class="mt-3">Fichier sélectionné: {{ form.list ? form.list.name : '' }}</div>
            <b-row class="text-center mt-3">
              <b-col>
                <b-button
                  class="text-center"
                  type="submit"
                  variant="primary">Importer</b-button>
              </b-col>
            </b-row>

          </b-form>
        </b-modal>
      </b-col>
    </b-row>

    <b-form-group
      id="input-group-documents"
      label="Documents"
      label-for="input-documents">
      <b-form-select
        v-model="form.train_documents"
        :options="documentsValues"
        multiple/>
    </b-form-group>

    <b-row>
      <b-col class="text-center">
        <b-button
          type="submit"
          variant="primary">Enregistrer</b-button>
      </b-col>
    </b-row>

  </b-form>
</template>

<script>
export default {
  name: 'FormTraining',
  props: {
    id: {
      type: Number,
      default: null,
    },
    lesson: {
      type: Object,
      default: null,
    },
    offers: {
      type: Array,
      default: null,
    },
    needs: {
      type: Array,
      default: null,
    },
    usages: {
      type: Array,
      default: null,
    },
    documents: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      form: {
        train_id: null,
        train_name: '',
        train_description: '',
        train_usages: [],
        train_needs: [],
        train_offers: [],
        train_documents: [],
      },
      offersValues: [],
      needsValues: [],
      usagesValues: [],
      documentsValues: [],
    };
  },
  watch: {
    documents: {
      handler(val) {
        if (val) {
          this.documentsValues = [];
          const json = JSON.parse(JSON.stringify(val));
          for (let i = 0; i < json.length; i += 1) {
            this.documentsValues.push({ value: json[i].doc_ass_id, text: `[${json[i].doc_type}] ${json[i].doc_name}` });
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.mapValues();
    if (this.id) {
      this.form.train_id = this.id;
      this.form.train_name = this.lesson.fle_label;
      this.form.train_description = this.lesson.fle_description;
      this.form.train_offers = this.lesson.offers ? this.lesson.offers.map(o => o.off_id) : [];
      this.form.train_needs = this.lesson.needs ? this.lesson.needs.map(n => n.fne_id) : [];
      this.form.train_usages = this.lesson.usages ? this.lesson.usages.map(u => u.fus_id) : [];
      this.form.train_documents = this.lesson.documents ? this.lesson.documents.map(d => d.doc_ass_id) : [];
    }
    // this.$store.dispatch('participants/getParticipantById', this.id);
    // const data = this.$store.getters['participants/participantById'](this.id);
    // this.mapParticipant(data);
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$emit('sendForm', JSON.stringify(this.form), this.lesson);
    },
    onSubmitDocument(evt) {
      evt.preventDefault();
      const formData = new FormData();
      formData.append('file', this.form.list);
      this.$store.dispatch('contracts/importTrainingDocument', formData)
        .then((response) => {
          this.$root.$emit('bv::hide::modal', 'modal-document-add');
          this.documentsValues.push({ value: response.doc_ass_id, text: `[${response.doc_type}] ${response.doc_name}` });
          this.form.train_documents.push(response.doc_ass_id);
        })
        .catch(err => console.log(err));
      this.$emit('addDocument', formData);
    },
    mapValues() {
      try {
        let json = JSON.parse(JSON.stringify(this.offers));
        for (let i = 0; i < json.length; i += 1) {
          this.offersValues.push({ value: json[i].off_id, text: json[i].off_name });
        }
        json = JSON.parse(JSON.stringify(this.needs));
        for (let i = 0; i < json.length; i += 1) {
          this.needsValues.push({ value: json[i].need_id, text: json[i].need_label });
        }
        json = JSON.parse(JSON.stringify(this.usages));
        for (let i = 0; i < json.length; i += 1) {
          this.usagesValues.push({ value: json[i].usage_id, text: json[i].usage_label });
        }
        json = JSON.parse(JSON.stringify(this.documents));
        for (let i = 0; i < json.length; i += 1) {
          this.documentsValues.push({ value: json[i].doc_ass_id, text: `[${json[i].doc_type}] ${json[i].doc_name}` });
        }
      } catch (e) {
        console.log(e);
      }
    },
    // mapParticipant(data) {
    //  this.form = data;
    // }
  },
};
</script>

<style scoped>
.separation_line {
  width: 100%;
  margin: 20px auto;
  height: 1px;
  background: #cacaca;

}
</style>
